import { deepMerge } from '@antfu/utils'
import relativeTime from 'dayjs/plugin/relativeTime'
import { createVuetify } from 'vuetify'
import { VBtn } from 'vuetify/components/VBtn'
import defaults from './defaults'
import { icons } from './icons'
import { staticPrimaryColor, themes } from './theme'
// Styles
import { cookieRef } from '@/@layouts/stores/config'
import DayJsAdapter from "@date-io/dayjs"
import 'vuetify/styles'
import '@core/scss/template/libs/vuetify/index.scss'
const dayJsAdapter = new DayJsAdapter({ locale: "fr" });
dayJsAdapter.rawDayJsInstance.extend(relativeTime)
export const dateAdapter = dayJsAdapter
export default function (app) {
  const cookieThemeValues = {
    defaultTheme: resolveVuetifyTheme(),
    themes: {
      light: {
        colors: {
          primary: cookieRef('lightThemePrimaryColor', staticPrimaryColor).value,
        },
      },
      dark: {
        colors: {
          primary: cookieRef('darkThemePrimaryColor', staticPrimaryColor).value,
        },
      },
    },
  }

  const optionTheme = deepMerge({ themes }, cookieThemeValues)

  const vuetify = createVuetify({
    aliases: {
      IconBtn: VBtn,
    },
    defaults,
    icons,
    theme: optionTheme,
    date: {
      adapter: dayJsAdapter
    }
  })

  app.use(vuetify)
}
